export default __webpack_public_path__ + "static/media/detail_big_14_1.15bf190c.jpg";